import React from 'react';
import { rowHasAlerts } from './summaryDisplayUtils';

type Props = {
  row: { alertsCount?: string | number; alerts?: unknown[] };
  onAlertsClick: (row: Props['row']) => void;
  badgeClassName?: string;
};

const SummaryAlertsCell: React.FC<Props> = ({ row, onAlertsClick, badgeClassName = '' }) => {
  if (!rowHasAlerts(row)) {
    return null;
  }

  const count = row.alertsCount || (Array.isArray(row.alerts) ? row.alerts.length : 0);

  return (
    <div className="alerts-container" onClick={() => onAlertsClick(row)} style={{ cursor: 'pointer' }}>
      <span className={`content-link alert-badge ${badgeClassName}`.trim()}>{count}</span>
    </div>
  );
};

export default SummaryAlertsCell;
